// filters the column picker sections as well
// as the values within the sections based on the search value
export const filterDataSets = (value, dataSets) => {
	const filteredDataSets = dataSets
		.map((dataSet) => {
			const filtered = dataSet.values.filter((data) => data.label.toLowerCase().includes(value.toLowerCase()));
			if (filtered.length > 0) {
				const dataSetCopy = { ...dataSet };
				dataSetCopy.values = filtered;
				return dataSetCopy;
			}
			return null;
		})
		.filter((dataSet) => dataSet !== null);
	return filteredDataSets;
};
